import { RefObject, useState } from "react";
import { ReactTyped } from "react-typed";
import DosModal from "../components/DosModal";

interface Job {
    company: string;
    title: string;
    dates: string;
    clients?: string[];
    technologies: string[];
}

const jobs: Job[] = [
    {
        company: "Callibrity",
        title: "Senior Software Engineering Consultant",
        dates: "2026 - Present",
        clients: ["Western & Southern Financial Group"],
        technologies: ["C#", "MongoDB", "Kafka", "Terraform", "Azure"],
    },
    {
        company: "Bullhorn",
        title: "Software Engineer II / III",
        dates: "2020 - 2026",
        technologies: ["Java/Spring", "Angular/Typescript", "SQL", "Kafka", "MCP/LLM"],
    },
    {
        company: "PerkinElmer",
        title: "Software Engineer",
        dates: "2019 - 2020",
        technologies: ["VB.NET", "C#", "SQL"],
    },
    {
        company: "MRI Software",
        title: "Software Engineer I / II",
        dates: "2018 - 2019",
        technologies: ["C#/ASP.NET", "VB6", "Angular/Typescript", "SQL"],
    },
];

function WorkHistory({passedRef}: {passedRef: RefObject<HTMLDivElement>}) {
    const [openJob, setOpenJob] = useState<Job | null>(null);

    return (
        <div id={"work-history"} ref={passedRef}  className="container section">
            <div className="row">
                <div className="col-sm-4 image-container">
                    <img src="/bullhorn.jpg" alt="Bullhorn HQ"/>
                </div>
                <div className="col-sm-8">
                    <ReactTyped className="header" strings={["Work History"]} cursorChar="_"/>
                    <ul className="dos-list">
                        {jobs.map((job) => (
                            <li key={job.company}>
                                <button className="dos-entry" onClick={() => setOpenJob(job)}>
                                    <span className="dos-entry-name">{job.company}</span>
                                    <span className="dos-entry-meta">{job.dates}</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            {openJob && (
                <DosModal title={`C:\\WORK_HISTORY\\${openJob.company.toUpperCase().replace(/\s+/g, "_")}.TXT`}
                          onClose={() => setOpenJob(null)}>
                    <h1>{openJob.company}</h1>
                    <h3>{openJob.title}</h3>
                    <h4>{openJob.dates}</h4>
                    {openJob.clients && (
                        <>
                            <h4>Clients:</h4>
                            <ul>
                                {openJob.clients.map((client) => <li key={client}>{client}</li>)}
                            </ul>
                        </>
                    )}
                    <h4>Relevant Technologies:</h4>
                    <ul>
                        {openJob.technologies.map((tech) => <li key={tech}>{tech}</li>)}
                    </ul>
                </DosModal>
            )}
        </div>
    );
  }

  export default WorkHistory;
